import string_utilities from "./StringUtilities"

const chrono = require("chrono-node")

const handles_dates = {
    mixins: [string_utilities],
    methods: {
        standardized_range_object (date_data) {
            if((typeof date_data === "object") && !this.$moment.isMoment(date_data) && (typeof date_data.from !== "undefined")) {
                if(!this.$moment.isMoment(date_data.from)) date_data.from = this.$moment(date_data.from)
                if(!this.$moment.isMoment(date_data.to)) date_data.to = this.$moment(date_data.to)
                return date_data
            }
            const date = this.$moment(date_data)
            return { from: date, to: date }
        },
        standardized_date (date_data) {
            if(!date_data) return null
            if(date_data && this.$moment.isMoment(date_data)) return date_data
            return this.$moment(date_data)
        },
        format_date_time (date_data, format = "YYYY-MM-DD @ HH:mm") {
            if(!date_data || ((typeof date_data === "object") && !this.$moment.isMoment(date_data) && !date_data.from && !date_data.to)) return ""
            if((typeof date_data === "object") && !this.$moment.isMoment(date_data) && (!!date_data.from || !!date_data.to)) {
                if(!!date_data.from && !!date_data.to) {
                    const from = this.standardized_date(date_data.from)
                    const to = this.standardized_date(date_data.to)
                    const same_day = from && to ? from.isSame(to, "day") : false
                    if(same_day && !!format.match(/HH:mm/)) return this.string_concat(same_day ? "-" : " -- ", from.format(format), to.format(same_day ? "HH:mm" : format))
                    else if(same_day) return from.format(format)
                    return this.string_concat(" -- ", from.format(format), to.format(format))
                }
                return this.standardized_date(date_data.from).format(format)
            }
            return this.standardized_date(date_data).format(format)
        },
        parse_date (value) {
            let date
            try {
                date = this.$moment(chrono.parseDate(value))
            } catch (error) {
                date = null
            }
            return date
        }
    }
}

export default handles_dates
